import React from 'react'
import { FaPencilAlt } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type CanWriteControlProps = {
  onClick?: () => void
  canWrite: boolean
  viewOnly?: boolean
}

const CanWriteControl = ({ onClick, canWrite, viewOnly }: CanWriteControlProps) => {
  return (
    <div className={cn('control', 'permissions-control', { selected: canWrite, viewOnly })} data-graph-type="control">
      <a className={cn('icon')} onClick={onClick} title="Writer">
        <FaPencilAlt aria-hidden />
        <span className="sr-only">Can Write</span>
      </a>
    </div>
  )
}

export default CanWriteControl
